// extracted by mini-css-extract-plugin
export var active = "PaginationControls-module--active--5e8bf";
export var container = "PaginationControls-module--container--db7d2";
export var disabled = "PaginationControls-module--disabled--6abc8";